enum Roles {
  ContentManager = "Content Manager",
  FormEditor = "Form Editor",
  ITAdmin = "IT Admin",
  NonEmoryPublic = "Non-Emory Public",
}

export default Roles;
